import { useState, useEffect } from 'react';
import fetcher from '../../../Helpers/Fetcher/fetchApi';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { imgUrl } from '../../../Helpers/Constant';

const SingleEventSpeaker = ({ id }: any) => {
  const [speakers, setSpeakers] = useState<any>([]);
  useEffect(() => {
    (async () => {
      const res = await fetcher.get(`/api/fair/event/get/all/speaker/by/${id}`);
      console.log(res.data);
      if (res.success) {
        setSpeakers(res.data);
      }
    })();
  }, [id]);
  return (
    <div>
      <Row xs={12} md={4}>
        {speakers?.map((speaker: any) => {
          return (
            <Col>
              <div className='single-speakers-box'>
                <div className='speakers-image'>
                  <img
                    className='w-100'
                    height={200}
                    src={
                      speaker.guest_speaker_photo
                        ? `${imgUrl}/${speaker.guest_speaker_photo}`
                        : '/blank-image.png'
                    }
                    alt=''
                  />
                </div>

                <div className='speakers-content'>
                  <div className='top-content text-center'>
                    <h5>{speaker.guest_speaker_name}</h5>
                    <div>
                      <p className='fw-bold' style={{ color: '#3d3939' }}>
                        {speaker.guest_speaker_designation}{' '}
                      </p>
                      <p className='pb-2 text-muted fw-bold'>
                        {speaker.guest_speaker_company_name}{' '}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default SingleEventSpeaker;
